








import { Component, Vue } from "vue-property-decorator";
import { ajaxDeviceInfo, ajaxOperateComponent } from "@/server";
// 声明组件*****************
@Component({
  components: {
    
  }
})
export default class ComponentDetail extends Vue {
  // 属性*****************
  private type: string = "loading";
  private electricity: number = 0;
  private status: boolean = false;
  private device_component: object = {
    dtu_id: '',
    component_code: '',
    status: '01000000',
  };
  private detailsShowData: Array<any> = [
    [
      {
        id: "device_name",
        name: "设备名称",
        value: '',
        jpath: 'info_device.name'
      },
      {
        id: "compos_specific",
        name: "位置",
        value: '',
        jpath: 'info_device.specific'
      },
      {
        id: "device_status",
        name: "状态",
        value: '',
        jpath: 'info_device.enum_device_status.name'
      },
    ]
  ];
  created(): void {
    document.title = "设备详情";
  }
  mounted(): void {
    this.getDeviceInfo();

  }
  // 方法*****************
  private getDeviceInfo(): void {
    this['$indicator'].open({
        text: '加载中...',
    });
    ajaxDeviceInfo({
        uid: this.$store.state.user_info.info_user.user_id,
        device_id: this["$getObjectValue"](this["$route"], "query.device_id"),
        device_type: this["$getObjectValue"](this["$route"], "query.device_type")
    }).then(res => {
        this['$getDataInit'](this.detailsShowData, res.data);
        this.detailsShowData[0].find(x=>{
            if(x.id=='device_name'){
                x.value = this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_name')||{}).jpath||'')
                        ?this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_name')||{}).jpath||'')
                        :this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'model_name')||{}).jpath||'');
                return true
            }

        })
        this.device_component = {
          dtu_id: this['$getObjectValue'](res.data,'info_device_component.dtu_id'),
          component_code: this['$getObjectValue'](res.data,'info_device_component.component_code'),
          status: '',
        };
        this.electricity = this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_electricity')||{}).jpath||'')==-1
                          ?0
                          :this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_electricity')||{}).jpath||'');

        this.status = this['$getObjectValue'](res.data,'info_device.enum_device_status.id')=='904'?true:false;
    }).catch(error => {
        console.log(error);
    }).finally(res=>{
      this['$indicator'].close();
    });
  }

  private changeSwitch(data): void {
    console.log(data,"data");
    if(data){
      ajaxOperateComponent({
        info_device_component: {
          ...this.device_component,
          status: '01010000'
        }
      }).then(res=>{
        if(res.code=='0'){
            this.getDeviceInfo();
            this['$message']({
              value: '开启成功',
            });
        }
        else{
          this['$message']({
          value: '开启失败',
          });
        }
      
      }).catch(error=>{

      }).finally(data=>{

      })
    }else{
      ajaxOperateComponent({
        info_device_component: {
          ...this.device_component,
          status: '01000000'
        }
      }).then(res=>{
         if(res.code=='0'){
            this.getDeviceInfo();
            this['$message']({
              value: '关闭成功',
            });
        }
        else{
          this['$message']({
          value: '关闭失败',
          });
        }
      }).catch(error=>{

      }).finally(data=>{
        
      })
    }
  }

}
